import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién estoy arrancando como docente de Gestión Ambiental?',
    a: 'Sí. El Tomo 1 empieza desde los fundamentos absolutos y cada tomo tiene una lógica didáctica progresiva. El sistema está pensado tanto para docentes que inician como para los que ya tienen años de experiencia y quieren profesionalizar su material con legislación actualizada y ejemplos argentinos reales.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. Los PDFs son de alta calidad y están optimizados para leer en pantalla o imprimir.'
  }, {
    q: '¿El Nivel Experto es necesario?',
    a: 'Depende de tu objetivo. Si solo querés mejorar tus clases y tener actividades, evaluaciones y proyectos listos, el Megapack base es suficiente y completo. Si querés además un sistema de gestión institucional, herramientas para comunicarte con familias, certificar a tus alumnos y posicionarte como referente de EA, el Nivel Experto es la mejor inversión de tu carrera docente.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día podés tener una actividad del Bonus 1 aplicada en el aula y una evaluación del Bonus 2 lista para fotocopiar. Los tomos los podés leer a tu ritmo. La mayoría de docentes implementa cambios visibles en la primera semana de clases.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a packcentral23@gmail.com dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.'
  }, {
    q: '¿Aplica para cualquier nivel educativo?',
    a: 'Sí. Secundario, terciario, formación docente o universitario inicial. Todo el contenido está adaptado al sistema educativo argentino real con vocabulario graduado y actividades para distintos niveles. También aplica para docentes de cualquier asignatura que necesiten incorporar la Ley 27.621.'
  }, {
    q: '¿Necesito conocimientos avanzados de Gestión Ambiental para usarlo?',
    a: 'No. Cada tomo empieza desde lo conceptual y avanza con claridad. Si sos docente de Geografía, Ciencias Naturales o Formación Ciudadana sin especialización ambiental, este material fue pensado especialmente para vos.'
  }, {
    q: '¿Me ayuda a cumplir con la Ley 27.621?',
    a: 'Sí. Todo el MEGAPACK está diseñado en base a la Ley 27.621 de Educación Ambiental Integral y la Ley Yolanda. Si una inspección te pregunta cómo estás incorporando la EA en tu práctica, este material es tu respuesta documentada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#ece2cd]" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-49">
        <h2 className="text-3xl font-black text-center text-[#1e4230] mb-12 font-[Merriweather,_serif]" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-[#e0d6bf] rounded-2xl overflow-hidden bg-white" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-[#c8971b] hover:bg-[#f5efe1] transition-colors" aria-expanded={openIndex === i} data-id="element-53">
                <span className="font-bold text-[#1e4230] pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#c8971b] transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-[#4a4133] leading-relaxed border-t border-[#e0d6bf] pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}